export function buildUrlQuery(keyValuePairs) {
  return Object.entries(keyValuePairs).map(function (pair) {
    return pair.map(encodeURIComponent).join('=');
  }).join('&');
}